import { render, staticRenderFns } from "./Page_DiscountPartners.vue?vue&type=template&id=2fa612be&scoped=true&"
import script from "./Page_DiscountPartners.vue?vue&type=script&lang=js&"
export * from "./Page_DiscountPartners.vue?vue&type=script&lang=js&"
import style0 from "./Page_DiscountPartners.vue?vue&type=style&index=0&id=2fa612be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa612be",
  null
  
)

export default component.exports